export default {
  email: "",
  otp: "",
};
